import {ajaxRest} from './ajaxBase'

const CONTROLLER_PREFIX = 'org'

function getOrgStatistics (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/statistics` + param,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getOrganization () {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getOrganizationTotalCount () {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/count`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getAdminOrganization () {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/admin`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function updateOrg (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'put',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function addOrg (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'post',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function deleteOrg (param) {
  let p = new Promise((resolve, reject) => {
    // console.log('come in')
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'delete',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}
export default { getOrgStatistics, getOrganization, getOrganizationTotalCount, getAdminOrganization, updateOrg, addOrg, deleteOrg }



// WEBPACK FOOTER //
// ./src/api/orgManageAPI.js